import React from 'react';
import classes from './DotsLoader.module.scss';
import { Stack } from 'new/elements/Stack';
import Typography from 'new/elements/Typography';
import { ReactComponent as InfoIcon } from 'new/components/icons/fi-rr-info.svg';
import Tooltip from 'js/components/elements/mui/Tooltip';
import { Status } from 'new/components/pipelines/PipelineStatusChip/PipelineStatusChip';

export type RuntimeStatusIndicatorProps = {
  hideInfo?: boolean;
  ingestionMode?: 'sampling' | 'full_ingestion';
  runtimeStatus?: 'IDLE' | 'PROCESSING';
  status?: Status;
};

export const RuntimeStatusIndicator = (props: RuntimeStatusIndicatorProps) => {
  const { hideInfo, ingestionMode, runtimeStatus, status } = props;

  const isProcessing = runtimeStatus === 'PROCESSING';
  const isSampling = ingestionMode === 'sampling';
  const canShowInfo = !hideInfo && isSampling;

  if (!canShowInfo && !isProcessing) {
    return null;
  }

  return (
    <Stack direction="row" className={classes.root} alignItems="center" gap="8px">
      {canShowInfo && isSampling && (
        <>
          <Typography variant="bodySmall">Sampling Mode</Typography>
          <Tooltip
            tooltipTheme="fieldInfo"
            title={
              <>
                <p>
                  This source is currently in <b>Sampling Mode</b>. In this mode, the platform
                  efficiently analyzes a subset of your data, enabling quicker setup and testing
                  without the overhead of full ingestion.
                </p>
                <p>
                  The platform will seamlessly transition to full ingestion once a destination is
                  configured, but you have the flexibility to switch modes at any time.
                </p>
              </>
            }
          >
            <InfoIcon className={classes.infoIcon} />
          </Tooltip>
        </>
      )}
      {isProcessing && status === 'ACTIVE' && (
        <div className={classes.animationContainer}>
          <div className={classes.dotsLoader} />
        </div>
      )}
    </Stack>
  );
};
